export const SCHEMA = {
  id: null,
  assets: null,
  format: null,
  body: null,
  title: null,
  author: null,
  createdTimestamp: -1,
  dateTimeText: null,
  mainImage: null,
  commentCount: 0,
  siteSegment: {
    id: -1,
    name: null,
  },
  seo: {
    title: null,
    description: null,
    robots: {
      noIndex: false,
      noFollow: false,
    },
  },
  social: {
    og: {
      title: null,
      image: null,
      description: null,
      type: null,
      url: null,
    },
  },
  vote: 0,
  voteDown: 0,
  _dataError: false,
}

export const ASSETS_VIDEO_TILE_SCHEMA = {
  id: null,
  type: null,
  path: null,
  data: {
    type: null,
    id: null,
    title: null,
    heroImage: {
      small: null,
      mediumSmall: null,
      medium: null,
      large: null,
    },
    duration: null,
    vote: null,
    voteDown: null,
    url: null,
    episode: null,
    season: null,
    seriesTitle: null,
    seriesPath: null,
    host: null,
    guest: null,
    year: null,
    yogaLevel: null,
    yogaStyle: null,
    fitnessLevel: null,
    fitnessStyle: null,
    meditationStyle: null,
    feature: {
      id: null,
      offerings: {
        availability: null,
        subscriptions: [],
      },
      georestrictions: {
        availability: null,
        countries: {},
      },
      duration: 0,
    },
    preview: {
      id: null,
      offerings: {
        availability: null,
        subscriptions: [],
      },
      georestrictions: {
        availability: null,
        countries: {},
      },
      duration: 0,
    },
  },
}
